import { PricingPlans } from '@/components/billing/pricing-plans';
import { PlansComparison } from '@/components/billing/plans-comparison';
import { PlansFAQ } from '@/components/billing/plans-faq';
import { CommunitySection } from '@/components/billing/community-section';
import { CreditsUsageSection } from '@/components/billing/credits-usage-section';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

interface PricingLayoutProps {
  title?: string;
  description?: string;
  buttonLabel?: string;
}

export const PricingLayout = ({
  title = 'Pricing Plans',
  description = 'Choose the perfect plan for your needs.',
  buttonLabel,
}: PricingLayoutProps) => {
  const [activeTab, setActiveTab] = useState('subscription');
  const router = useRouter();
  const onTabChange = (tab: string) => {
    setActiveTab(tab);
    router.push(`#${tab}`);
  };

  // change active tab if url has #credits
  useEffect(() => {
    const hash = router.asPath.split('#')[1];
    if (hash) {
      setActiveTab(hash);
    }
  }, [router.asPath]);

  return (
    <div className="flex w-full flex-col">
      <div className="my-2 flex w-full flex-col p-4 sm:my-6 lg:px-40">
        <div className="mx-auto w-full max-w-[1200px]">
          <div className="space-y-4 sm:space-y-6">
            <div className="mb-8 flex flex-col items-center justify-center space-y-4 text-center">
              <h1 className="text-4xl font-bold sm:text-5xl">{title}</h1>
              <p className="text-muted-foreground max-w-2xl text-lg">
                {description}
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_300px]">
              <div id="pricing-plans">
                <PricingPlans
                  buttonLabel={buttonLabel}
                  activeTab={activeTab}
                  onTabChange={onTabChange}
                />
              </div>
              <div className="h-full">
                <CreditsUsageSection />
              </div>
            </div>
          </div>
        </div>
      </div>

      <PlansComparison />
      <CommunitySection />
      <PlansFAQ />
    </div>
  );
};
